import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from './Main';
import Footer from './Footer';
import LoanEligibilityCalculator from './LoanEligibilityCalculator';
import ThankYouPage from './ThankYouPage'; 
import PartnerPage from './Partners';
import Termsandcondition from './Termandcondition';
import Privacypolicy from './Privacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Main />
            <LoanEligibilityCalculator />
            <PartnerPage/>
            <Footer />
          </>
        } />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/terms-and-conditions" element={<Termsandcondition />} />
        <Route path="/Privacy-policy" element={<Privacypolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
